// Components==============
import { faCheck, faRepeat } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import React, { useContext, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { HomeContext } from 'screens/Home/Home';
import './Tile.module.scss';
import { faUsers } from '@fortawesome/pro-solid-svg-icons';
// =========================

type TileProps = {
    id: number;
    name: string;
    homework: number[];
    image?: string;
    open: number;
    finished: number;
    index: number;
    number?: string;
    isRepeat?: 1 | 0;
};

export default function Tile({
    id,
    name,
    homework,
    image,
    open,
    finished,
    index,
    number,
    isRepeat,
}: TileProps) {
    const ref = useRef<HTMLDivElement>(null);
    const {
        path,
        currentTile,
        setCurrentTile,
        setOpenThermometer,
        setOpenVideo,
    } = useContext(HomeContext);
    const history = useHistory();

    useEffect(() => {
        if (currentTile.id === index) {
            setCurrentTile((prev) => ({
                ...prev,
                ref,
            }));
        }
    }, [currentTile?.id]);

    const goToHomework = () => {
        if (number === 'V1' && (open || finished)) {
            return setOpenVideo(id);
        }
        if (!open) {
            return;
        }

        if (name.includes('Wat vind jij')) {
            if (number === 'T1a') {
                return setOpenThermometer('1a');
            }
            if (number === 'T1b') {
                return setOpenThermometer('1b');
            }
            const parsedNumber = number
                ? parseInt(number[number.length - 1])
                : 0;
            return setOpenThermometer(parsedNumber);
        }

        history.push(
            `/${id}/homework/${
                homework && homework.length > 0 ? homework[0] : null
            }`
        );
    };

    const getTopIconForFile = () => {
        if (open === 1) {
            return (
                <div
                    styleName={`top-icon marker ${finished ? 'checked' : ''} ${
                        isRepeat ? 'repeat' : ''
                    }`}
                />
            );
        }
        if (finished === 1) {
            return (
                <div
                    styleName={`top-icon checkbox ${isRepeat ? 'repeat' : ''}`}
                >
                    <FontAwesomeIcon icon={isRepeat ? faRepeat : faCheck} />
                </div>
            );
        }
        // return <div styleName="top-icon circle " />;
    };

    return (
        <div styleName={`tile ${path}`} ref={ref}>
            <motion.div
                styleName="tile-content"
                whileHover={{ scale: 1.08 }}
                transition={{ duration: 0.5 }}
                whileTap={{ scale: 0.88 }}
                onClick={goToHomework}
            >
                <img src={`/storage/${image}`} alt={name} />
                <div styleName="top-icon-wrapper">
                    {getTopIconForFile()}
                    <div styleName="popup-text">
                        <h6>{name}</h6>
                    </div>
                </div>
            </motion.div>
        </div>
    );
}
